export default __webpack_public_path__ + "static/media/pindark.b5cfc149.svg";